import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FocusSection from './components/FocusSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <TopicsSection />
        <CardsSection />
        <FAQSection />
        <CommentsSection />
        <ContactSection />
        <RankingSection />
        <FocusSection />
        <FeaturesSection />
        <IndexSection />
        <UpdatesSection />
        <MediaSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}